import type { ReactNode } from "react";
import { useEffect } from "react";
import * as Styled from "./style";

type Args = {
  firstLineMainText: string;
  secondLineMainText: string;
  topSubText?: string;
  bottomSubText?: ReactNode;
  buttonText: string;
  onClickBanner: () => void;
  onMountBanner?: () => void;
};

export const PremiumAppealBanner = (args: Args) => {
  const { firstLineMainText, secondLineMainText, topSubText, bottomSubText, buttonText, onClickBanner, onMountBanner } =
    args;

  useEffect(() => {
    onMountBanner && onMountBanner();
  }, []);

  return (
    <Styled.ButtonActionWrapper
      type="button"
      name="プレミアム入会導線ボタン"
      aria-label="プレミアム入会導線ボタン"
      onClick={onClickBanner}
    >
      <Styled.GridContainer>
        <Styled.DivSummaryWrapper>
          {topSubText && <Styled.ParSubSummary>{topSubText}</Styled.ParSubSummary>}
          <Styled.ParSummary>{firstLineMainText}</Styled.ParSummary>
          <Styled.ParSummary>{secondLineMainText}</Styled.ParSummary>
          {bottomSubText && <Styled.ParSubSummary>{bottomSubText}</Styled.ParSubSummary>}
        </Styled.DivSummaryWrapper>
        <Styled.AnchorPurchase>{buttonText}</Styled.AnchorPurchase>
      </Styled.GridContainer>
    </Styled.ButtonActionWrapper>
  );
};
